import { useState } from "react";

interface UsePaginationOptions {
  pageSize: number;
  total: number;
}

/**
 * Provide pagination states
 * `startIndex` and `endIndex` are zero-based
 */
export function usePagination({ pageSize, total }: UsePaginationOptions) {
  const [currentPage, setCurrentPage] = useState(1);
  const endIndexOfPage = (currentPage - 1) * pageSize + pageSize - 1;
  return {
    currentPage,
    startIndex: (currentPage - 1) * pageSize,
    endIndex: Math.min(endIndexOfPage, total - 1),
    totalNumberOfPages: Math.ceil(total / pageSize),
    back: () => {
      if (currentPage > 1) {
        setCurrentPage((prevPage) => prevPage - 1);
      }
    },
    next: () => {
      if (!(currentPage * pageSize >= total)) {
        setCurrentPage((prevPage) => prevPage + 1);
      }
    },
    setCurrentPage: (page: number) => {
      setCurrentPage(page);
    },
  };
}
